import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        questionCategory: '='
    },
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <ul class="actions01">
                    <li>
                        <forms-settings-questioncategories-translation
                             ng-if="vm.QuestionService.canManageQuestionRelatedData()"
                             form="vm.form"
                             question-category="vm.questionCategory"
                        />
                    </li>
                    <li>
                        <a ui-sref="authorized.forms.settings.questioncategories.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a>
                    </li>
                </ul>
                <h1>{{ 'questionCategory.Category name' | translate }}</h1>
            </div>
            <div class="well">
                <h2>{{ 'questionCategory.General data' | translate }}</h2>
                <form>
                <div class="form">
                    <forms-settings-questioncategories-generaldata form="vm.form"></forms-settings-questioncategories-generaldata>
                </div>
                </form>
            </div>
            <div class="well color02">
                <h2>{{ 'questionCategory.Questions' | translate }}</h2>
                <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
                <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.list.items.length && !vm.loading">
                    <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'questions.Name' | translate }}</a></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="question in vm.list.items">
                            <td><a ui-sref="authorized.forms.questions.all.question({ id: question.id })">{{ question.activeI18n.name }}</a></td>
                        </tr>
                    </tbody>
                </table>
            <pagination list="vm.list"></pagination>
            </div>
            <ul class="actions01">
                <li ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="primary"><a class="btn main" ng-click="vm.save()">{{ 'general.Save' | translate }}</a></li>
                <li><a ui-sref="authorized.forms.settings.questioncategories.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($state, DATATABLES, FormFactory, ListFactory, QuestionResource, QuestionService) {
        this.$state = $state;
        this.DATATABLES = DATATABLES;
        this.QuestionService = QuestionService;

        this.form = FormFactory.create(this.questionCategory, model => model.$update({ id: model.id }));

        this.list = ListFactory.createWithPagination(QuestionResource.query.bind(QuestionResource));

        this.list.fetch({ categoryId: this.questionCategory.id, expand: 'activeI18n' });
    }

    save () {
        this.form.save()
            .then(() => {
                this.$state.go('authorized.forms.settings.questioncategories.list');
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/questioncategories/edit/index.js